export class MatomoTracker {
    constructor(siteId) {
        this.cancelBuild = false;
        if (!siteId) {
            this.cancelBuild = true;
            return;
        }
        this.siteId = siteId;
        this.trackPageChange();
        this.initialize();
    }
    initialize() {
        if (!this.siteId) {
            console.error('Matomo siteId is required.');
        }
        if (typeof window === 'undefined') {
            return;
        }
        window._paq = window._paq || [];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
      var _paq = window._paq = window._paq || [];
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u="https://colliersusti.matomo.cloud/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '${this.siteId}']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src='//cdn.matomo.cloud/colliersusti.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
      })();
      `;
        document.head.appendChild(script);
    }
    identify(user) {
        const { displayName, email, userId } = user;
        if (!userId) {
            return console.error('Matomo - no userId');
        }
        this.pushInstruction('setUserId', userId);
        // customDimension 1 does not work. Bug in Matomo.
        if (!email) {
            return console.error('Matomo - no email');
        }
        this.pushInstruction('setCustomDimension', 2, email.toLocaleLowerCase());
        if (!displayName) {
            return console.error('Matomo - no displayName');
        }
        this.pushInstruction('setCustomDimension', 3, displayName);
    }
    pushInstruction(name, ...args) {
        if (typeof window === 'undefined') {
            return this;
        }
        return window._paq.push([name, ...args]);
    }
    trackEvent(data) {
        if (data) {
            const params = Object.values(data);
            this.pushInstruction('trackEvent', ...params);
        }
    }
    trackPageChange() {
        let previousUrl = '';
        const observer = new MutationObserver(() => {
            const currentUrl = window.location.href;
            if (currentUrl !== previousUrl) {
                window._paq.push(['setReferrerUrl', previousUrl]);
                window._paq.push(['setCustomUrl', currentUrl]);
                window._paq.push(['trackPageView']);
                previousUrl = currentUrl;
            }
        });
        const config = { subtree: true, childList: true };
        observer.observe(document, config);
    }
}
